// test1352
(1352 && 0);
